export default class Permissions {
	static CAN_VIEW_ORDERS              = 'can view orders'
	static CAN_VIEW_INSPECTIONS         = 'can view inspections'
	static CAN_MANAGE_INSPECTIONS       = 'can manage inspections'
	static CAN_VIEW_USERS               = 'can view users'
	static CAN_VIEW_VETTED_NOTES        = 'can view vetted notes'
	static CAN_VIEW_ASSETS              = 'can view assets'
	static CAN_TELEPORT_AS_COLLEAGUE    = 'can teleport as colleague'
	static CAN_TELEPORT_AS_MANAGED_USER = 'can teleport as managed user'
	static CAN_VIEW_DOCUMENTS           = 'can view documents'
	static CAN_MANAGE_FIRMS             = 'can manage firms'
	static CAN_VIEW_FIRMS               = 'can view firms'
	static CAN_MANAGE_OPERATIONS        = 'can manage operations'
	static CAN_VIEW_INVOICES            = 'can view invoices'
	static CAN_VIEW_BATCHES             = 'can view batches'
}



// WEBPACK FOOTER //
// ./src/helpers/permissions.js